// extracted by mini-css-extract-plugin
module.exports = {"ActivityReport":"styles_ActivityReport__3Z47m","ActivityPagination":"styles_ActivityPagination__1PdbS"};